import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { PublicCertificate } from '@core/models/public-certificate.model';
import { PublicMultiCertificate } from '@core/models/public-multi-certificate.model';

import moment from 'moment';

const ENDPOINT = 'multiCertificate';
const CERTIFICATES_ENDPOINT = 'certificate';

@Injectable()
export class PublicMultiCertificatesService {
  constructor(private http: HttpClient) {}

  getDetail(multiCertificateId: string): Observable<PublicMultiCertificate> {
    return this.http
      .get<PublicMultiCertificate>(`${ENDPOINT}/public/${multiCertificateId}`)
      .pipe(
        tap((multiCertificate: PublicMultiCertificate) =>
          formattedDate(multiCertificate.certificates)
        )
      );
  }

  downloadCertificate(certificateId: string): Observable<any> {
    return this.http.get<any>(
      `${CERTIFICATES_ENDPOINT}/file/${certificateId}`,
      {
        params: { download: 'true' },
        responseType: 'text' as 'json'
      }
    );
  }
}

function formattedDate(list: PublicCertificate[]): void {
  list.forEach((item: PublicCertificate) => {
    item.timestamp = moment(item.timestamp).format('DD/MM/YYYY HH:mm');
  });
}
